import React from "react";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown } from "aible";

import Slider from "rc-slider";

import { FRONTIER_SLIDERS_VIEW } from "containers/FrontierSliders/FrontierSliders";

import Toggle from "react-toggle";

import numeral from "numeral";

import styles from "./style.module.css";

export default class ContinuousRunFrontier extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { frontier, bestModel, isSingle } = this.props;

    let marks = {};
    frontier &&
      frontier.forEach((d, i) => {
        if (isNaN(d.bias)) {
          console.log(d);
        }
        marks[Number(d.bias)] = <div className={styles.dotHolder}></div>;
      });

    return (
      <div className={styles.continuousRunFrontier} style={isSingle ? { width: "100%" } : {}}>
        <div
          className={styles.continuousSlider}
          style={isSingle ? { width: "calc(100% - 10px)", marginLeft: "5px" } : {}}
        >
          <Slider
            style={{ pointerEvents: "none" }}
            min={Math.min.apply(
              Math,
              frontier.map((f) => f.bias)
            )}
            max={Math.max.apply(
              Math,
              frontier.map((f) => f.bias)
            )}
            marks={Object.keys(marks).length > 0 ? marks : undefined}
            included={false}
            step={frontier ? frontier.length : 0}
            trackStyle={{ backgroundColor: "transparent" }}
            handleStyle={{
              backgroundColor: "#F47C20",
              borderColor: "white",
              boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)",
              zIndex: 501,
              pointer: "cursor !important"
            }}
            value={bestModel ? bestModel.bias : 0}
          />
        </div>
        {isSingle !== true && (
          <div className={styles.continiousBias}>{numeral(bestModel ? bestModel.bias : 0).format("0.0a")}</div>
        )}
      </div>
    );
  }
}
